import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";
import { Spinner } from "../ui/spinner";
import { UPDATE_FORGE_LABEL } from "./cloudRuntimeRowActions";

export function ForceUpdateEnvironmentDialog({
  open,
  onOpenChange,
  environmentName,
  isUpdating,
  onConfirm,
}: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly environmentName: string;
  readonly isUpdating: boolean;
  readonly onConfirm: () => void;
}) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next && isUpdating) return;
        onOpenChange(next);
      }}
    >
      <AlertDialogPopup className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>
            Force update and repair &ldquo;{environmentName}&rdquo;?
          </AlertDialogTitle>
          <AlertDialogDescription>
            Forge will stop running turns and preserve their conversation state. You can resume
            those conversations after the repair.
          </AlertDialogDescription>
          <p className="mt-2 rounded-md border border-border/60 bg-secondary/30 p-3 text-sm text-muted-foreground">
            New turns stay blocked until the repair finishes. The Sprite, files, worktrees, and chat
            history stay in place.
          </p>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogClose render={<Button variant="outline" disabled={isUpdating} />}>
            Cancel
          </AlertDialogClose>
          <Button disabled={isUpdating} onClick={onConfirm}>
            {isUpdating ? <Spinner className="size-4" /> : null}
            {isUpdating ? "Stopping turns and repairing..." : UPDATE_FORGE_LABEL}
          </Button>
        </AlertDialogFooter>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
